import script from "./IconFree.vue?vue&type=script&setup=true&lang=js"
export * from "./IconFree.vue?vue&type=script&setup=true&lang=js"

import "./IconFree.vue?vue&type=style&index=0&id=6cfed1f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cfed1f1"]])

export default __exports__